import React, { useState } from 'react';
import { Typography, Card, Form, Input, Button, message, Space } from 'antd';
import MainLayout from '../../layouts/MainLayout';
import { financialApi } from '../../utils/financialApi';
import { extractApiUserMessage } from '../../utils/api';

const { Title, Text } = Typography;

const DiscountLimits = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const payload = {
        role_id: Number(values.role_id),
        max_discount_percent: Number(values.max_discount_percent),
        max_discount_amount: Number(values.max_discount_amount),
      };
      
      await financialApi.setDiscountLimit(payload);
      message.success('سقف تخفیف برای نقش مورد نظر با موفقیت تنظیم شد.');
      form.resetFields();
    } catch (error) {
      message.error(extractApiUserMessage(error) || 'خطا در ثبت سقف تخفیف');
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="p-4 md:p-6 pb-24 max-w-[1000px] mx-auto animate-fade-in">
        <div className="mb-6">
          <Title level={3} className="m-0 text-gray-800 dark:text-gray-100 font-bold">
            تنظیم سقف تخفیف
          </Title>
          <Text className="text-gray-500 dark:text-gray-400">
            تعیین سقف مجاز تخفیف بر اساس نقش سازمانی
          </Text>
        </div>

        <Card bordered={false} className="shadow-sm dark:bg-gray-800 rounded-2xl">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            className="max-w-md"
          >
            <Form.Item
              name="role_id"
              label="شناسه نقش سازمانی (Role ID)"
              rules={[{ required: true, message: 'لطفا شناسه نقش را وارد کنید' }]}
            >
              <Input type="number" placeholder="مثلاً: 4" />
            </Form.Item>

            <Form.Item
              name="max_discount_percent"
              label="حداکثر درصد تخفیف (%)"
              rules={[{ required: true, message: 'لطفا درصد تخفیف را وارد کنید' }]}
            >
              <Input type="number" step="0.1" placeholder="مثلاً: 10.0" />
            </Form.Item>

            <Form.Item
              name="max_discount_amount"
              label="حداکثر مبلغ تخفیف (تومان)"
              rules={[{ required: true, message: 'لطفا مبلغ تخفیف را وارد کنید' }]}
            >
              <Input type="number" placeholder="مثلاً: 15000000" />
            </Form.Item>

            <Form.Item className="mb-0 pt-4">
              <Space>
                <Button type="primary" htmlType="submit" loading={loading}>
                  ثبت تنظیمات
                </Button>
                <Button onClick={() => form.resetFields()}>
                  پاک‌کردن
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </MainLayout>
  );
};

export default DiscountLimits;
